import { render, staticRenderFns } from "./canvas-drag.vue?vue&type=template&id=58069a50&scoped=true&"
import script from "./canvas-drag.vue?vue&type=script&lang=js&"
export * from "./canvas-drag.vue?vue&type=script&lang=js&"
import style0 from "./canvas-drag.vue?vue&type=style&index=0&id=58069a50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58069a50",
  null
  
)

export default component.exports